/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvestorFirmSearch_InvestorFirmGridPartsFragment = {
  readonly __typename?: 'InvestorFirmsGrid';
  readonly id: string;
  readonly firmKey?: string | null;
  readonly linkedCmgEntityKey?: string | null;
  readonly name: string;
  readonly firmType?: string | null;
  readonly address1?: string | null;
  readonly address2?: string | null;
  readonly status: Types.RolodexRecordStatus;
  readonly salesCoverage?: {
    readonly __typename?: 'SalesCoverageCollectionSegment';
    readonly totalCount: number;
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmRelationship';
      readonly employeeName?: string | null;
    }> | null;
  } | null;
};

export type InvestorFirmSearch_InvestorFirmsQueryVariables = Types.Exact<{
  skip: Types.Scalars['Int']['input'];
  perPage: Types.Scalars['Int']['input'];
  where?: Types.InputMaybe<Types.InvestorFirmGridFilterInput>;
}>;

export type InvestorFirmSearch_InvestorFirmsQuery = {
  readonly __typename?: 'Query';
  readonly investorFirms?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
    readonly data?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly firmKey?: string | null;
      readonly linkedCmgEntityKey?: string | null;
      readonly name: string;
      readonly firmType?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly totalCount: number;
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeName?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type InvestorFirmSearch_CoveredInvestorFirmsQueryVariables = Types.Exact<{
  skip: Types.Scalars['Int']['input'];
  perPage: Types.Scalars['Int']['input'];
  where?: Types.InputMaybe<Types.InvestorFirmGridFilterInput>;
}>;

export type InvestorFirmSearch_CoveredInvestorFirmsQuery = {
  readonly __typename?: 'Query';
  readonly coveredInvestorFirms?: {
    readonly __typename?: 'CoveredInvestorFirmsGridCollectionSegment';
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
    readonly data?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly id: string;
      readonly firmKey?: string | null;
      readonly linkedCmgEntityKey?: string | null;
      readonly name: string;
      readonly firmType?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly totalCount: number;
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeName?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export const InvestorFirmSearch_InvestorFirmGridPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSearch_InvestorFirmGridParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relationshipStatus' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'lastUpdated' },
                          value: { kind: 'EnumValue', value: 'DESC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InvestorFirmSearch_InvestorFirmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InvestorFirmSearch_InvestorFirms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmGridFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'investorFirms' },
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'name' },
                          value: { kind: 'EnumValue', value: 'ASC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'data' },
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirmSearch_InvestorFirmGridParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSearch_InvestorFirmGridParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relationshipStatus' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'lastUpdated' },
                          value: { kind: 'EnumValue', value: 'DESC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInvestorFirmSearch_InvestorFirmsQuery__
 *
 * To run a query within a React component, call `useInvestorFirmSearch_InvestorFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirmSearch_InvestorFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorFirmSearch_InvestorFirmsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      perPage: // value for 'perPage'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvestorFirmSearch_InvestorFirmsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvestorFirmSearch_InvestorFirmsQuery,
    InvestorFirmSearch_InvestorFirmsQueryVariables
  > &
    (
      | { variables: InvestorFirmSearch_InvestorFirmsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvestorFirmSearch_InvestorFirmsQuery,
    InvestorFirmSearch_InvestorFirmsQueryVariables
  >(InvestorFirmSearch_InvestorFirmsDocument, options);
}
export function useInvestorFirmSearch_InvestorFirmsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvestorFirmSearch_InvestorFirmsQuery,
    InvestorFirmSearch_InvestorFirmsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvestorFirmSearch_InvestorFirmsQuery,
    InvestorFirmSearch_InvestorFirmsQueryVariables
  >(InvestorFirmSearch_InvestorFirmsDocument, options);
}
// @ts-ignore
export function useInvestorFirmSearch_InvestorFirmsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InvestorFirmSearch_InvestorFirmsQuery,
    InvestorFirmSearch_InvestorFirmsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  InvestorFirmSearch_InvestorFirmsQuery,
  InvestorFirmSearch_InvestorFirmsQueryVariables
>;
export function useInvestorFirmSearch_InvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvestorFirmSearch_InvestorFirmsQuery,
        InvestorFirmSearch_InvestorFirmsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  InvestorFirmSearch_InvestorFirmsQuery | undefined,
  InvestorFirmSearch_InvestorFirmsQueryVariables
>;
export function useInvestorFirmSearch_InvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvestorFirmSearch_InvestorFirmsQuery,
        InvestorFirmSearch_InvestorFirmsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvestorFirmSearch_InvestorFirmsQuery,
    InvestorFirmSearch_InvestorFirmsQueryVariables
  >(InvestorFirmSearch_InvestorFirmsDocument, options);
}
export type InvestorFirmSearch_InvestorFirmsQueryHookResult = ReturnType<
  typeof useInvestorFirmSearch_InvestorFirmsQuery
>;
export type InvestorFirmSearch_InvestorFirmsLazyQueryHookResult = ReturnType<
  typeof useInvestorFirmSearch_InvestorFirmsLazyQuery
>;
export type InvestorFirmSearch_InvestorFirmsSuspenseQueryHookResult = ReturnType<
  typeof useInvestorFirmSearch_InvestorFirmsSuspenseQuery
>;
export type InvestorFirmSearch_InvestorFirmsQueryResult = Apollo.QueryResult<
  InvestorFirmSearch_InvestorFirmsQuery,
  InvestorFirmSearch_InvestorFirmsQueryVariables
>;
export const InvestorFirmSearch_CoveredInvestorFirmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InvestorFirmSearch_CoveredInvestorFirms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmGridFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'coveredInvestorFirms' },
            name: { kind: 'Name', value: 'coveredInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'name' },
                          value: { kind: 'EnumValue', value: 'ASC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'data' },
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorFirmSearch_InvestorFirmGridParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirmSearch_InvestorFirmGridParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relationshipStatus' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'lastUpdated' },
                          value: { kind: 'EnumValue', value: 'DESC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInvestorFirmSearch_CoveredInvestorFirmsQuery__
 *
 * To run a query within a React component, call `useInvestorFirmSearch_CoveredInvestorFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirmSearch_CoveredInvestorFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorFirmSearch_CoveredInvestorFirmsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      perPage: // value for 'perPage'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInvestorFirmSearch_CoveredInvestorFirmsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvestorFirmSearch_CoveredInvestorFirmsQuery,
    InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
  > &
    (
      | { variables: InvestorFirmSearch_CoveredInvestorFirmsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvestorFirmSearch_CoveredInvestorFirmsQuery,
    InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
  >(InvestorFirmSearch_CoveredInvestorFirmsDocument, options);
}
export function useInvestorFirmSearch_CoveredInvestorFirmsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvestorFirmSearch_CoveredInvestorFirmsQuery,
    InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvestorFirmSearch_CoveredInvestorFirmsQuery,
    InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
  >(InvestorFirmSearch_CoveredInvestorFirmsDocument, options);
}
// @ts-ignore
export function useInvestorFirmSearch_CoveredInvestorFirmsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InvestorFirmSearch_CoveredInvestorFirmsQuery,
    InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  InvestorFirmSearch_CoveredInvestorFirmsQuery,
  InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
>;
export function useInvestorFirmSearch_CoveredInvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvestorFirmSearch_CoveredInvestorFirmsQuery,
        InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  InvestorFirmSearch_CoveredInvestorFirmsQuery | undefined,
  InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
>;
export function useInvestorFirmSearch_CoveredInvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvestorFirmSearch_CoveredInvestorFirmsQuery,
        InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvestorFirmSearch_CoveredInvestorFirmsQuery,
    InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
  >(InvestorFirmSearch_CoveredInvestorFirmsDocument, options);
}
export type InvestorFirmSearch_CoveredInvestorFirmsQueryHookResult = ReturnType<
  typeof useInvestorFirmSearch_CoveredInvestorFirmsQuery
>;
export type InvestorFirmSearch_CoveredInvestorFirmsLazyQueryHookResult = ReturnType<
  typeof useInvestorFirmSearch_CoveredInvestorFirmsLazyQuery
>;
export type InvestorFirmSearch_CoveredInvestorFirmsSuspenseQueryHookResult = ReturnType<
  typeof useInvestorFirmSearch_CoveredInvestorFirmsSuspenseQuery
>;
export type InvestorFirmSearch_CoveredInvestorFirmsQueryResult = Apollo.QueryResult<
  InvestorFirmSearch_CoveredInvestorFirmsQuery,
  InvestorFirmSearch_CoveredInvestorFirmsQueryVariables
>;

import { makeMockResponse } from '../../../../../../graphql/mock-response';

export const makeInvestorFirmSearch_InvestorFirmsMockResponse = makeMockResponse<
  InvestorFirmSearch_InvestorFirmsQueryVariables,
  InvestorFirmSearch_InvestorFirmsQuery
>(InvestorFirmSearch_InvestorFirmsDocument);

export const makeInvestorFirmSearch_CoveredInvestorFirmsMockResponse = makeMockResponse<
  InvestorFirmSearch_CoveredInvestorFirmsQueryVariables,
  InvestorFirmSearch_CoveredInvestorFirmsQuery
>(InvestorFirmSearch_CoveredInvestorFirmsDocument);
